import React from "react"
import styled from "styled-components"
//@ts-ignore
import {BlackCoins} from "../../../assets/icons/BlackCoins.jsx"

interface IProps {
  CoinsAmmount: number;
}

const Container = styled.div`
  background-color: #d9d9d922;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 22px;
  padding: 5px 15px;
  gap: 3px;
  border: 1px solid #7515ed;
`;

const Ammount = styled.p`
  color: white;
  font-size: 20px;
  font-weight: 700;
  pointer-events: none;
`;

const Title = styled.p`
  color: white;
  font-weight: 300;
  font-style: italic;
  pointer-events: none;
`;

export const BlackCoinsWallet = (props:IProps) => {
  return (
    <Container>
      <BlackCoins size={40}/>
      <Ammount>{props.CoinsAmmount}</Ammount>
      <Title>Blackcoins</Title>
    </Container>
  )
}